export const AbsenceUnitConst = {
  FULL_DAY: 1,
  PARTIAL: 2,
};

export const AbsenceUnitLabel: Record<number, string> = {
  [AbsenceUnitConst.FULL_DAY]: "Dia inteiro",
  [AbsenceUnitConst.PARTIAL]: "Parcial (horas)",
};

export const AbsenceStatusConst = {
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
  CANCELLED: 4,
};

export const AbsenceStatusLabel: Record<number, string> = {
  [AbsenceStatusConst.PENDING]: "Pendente",
  [AbsenceStatusConst.APPROVED]: "Aprovado",
  [AbsenceStatusConst.REJECTED]: "Reprovado",
  [AbsenceStatusConst.CANCELLED]: "Cancelado",
};

export type AbsenceTypeProps = {
  unity_id?: number | null;
  unity?: { id: number; name: string } | null;
  id: number;
  uuid: string;
  name: string;
  description?: string | null;
  unit: number;
  requires_document: boolean;
  counts_as_worked_hours: boolean;
  is_active: boolean;
  is_vacation: boolean;
  tenant_id: number;
  created_at: string;
  updated_at: string | null;
  deleted_at: string | null;
};

export type AbsenceTypeSelectProps = {
  id: number;
  name: string;
  unit: number;
  requires_document: boolean;
  is_vacation: boolean;
};
